import React from 'react';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import { token } from '@atlaskit/tokens';
import { Box, Flex } from '@atlaskit/primitives';
import { InfoPanel } from '../../../info-panel';
import { SidebarContainer, PaneContainer, CloseButton, FixedCloseButton, SidebarTitle } from './sidebarv2.styles';
import { SidebarOptions } from '../../../state/src/sidebar-slice';

type SidebarV2Props = {
  isSidebarOpen: boolean;
  closeSidebar: () => void;
  Pane: any;
  payload: Record<string, unknown>;
  sidebarOptions?: SidebarOptions;
};

const SidebarV2 = ({ isSidebarOpen, closeSidebar, Pane, payload, sidebarOptions }: SidebarV2Props) => {
  return (
    <SidebarContainer
      isSidebarOpen={isSidebarOpen}
      data-testid="sidebarv2-container"
      width={sidebarOptions?.sidebarWidth || '400px'}
      sideBarDistanceFromTop={sidebarOptions?.sideBarDistanceFromTop}
    >
      {isSidebarOpen && (
        <PaneContainer data-testid="pane-container">
          {sidebarOptions?.sidebarTitle ? (
            <Box
              testId="sidebar-title-container"
              {...{
                ...(sidebarOptions.shouldAddPaddingAfterTitle ? { paddingBlockEnd: 'space.200' } : {}),
              }}
            >
              <Flex justifyContent="space-between">
                {typeof sidebarOptions.sidebarTitle === 'string' ? (
                  <SidebarTitle>{sidebarOptions.sidebarTitle}</SidebarTitle>
                ) : (
                  sidebarOptions.sidebarTitle
                )}
                <CloseButton onClick={closeSidebar} data-testid="sidebar-close">
                  <CrossIcon size="small" label="Close Modal" primaryColor={token('color.text.subtlest')} />
                </CloseButton>
              </Flex>
            </Box>
          ) : (
            <FixedCloseButton onClick={closeSidebar} data-testid="sidebar-close">
              <CrossIcon size="small" label="Close Modal" primaryColor={token('color.text.subtlest')} />
            </FixedCloseButton>
          )}
          {Pane ? (
            <Pane data-testid="pane-test" {...payload} />
          ) : (
            <>
              <InfoPanel
                type="warning"
                title="The pane has not been setup yet"
                message="Please check the application and setup the sidebar panes"
              />
            </>
          )}
        </PaneContainer>
      )}
    </SidebarContainer>
  );
};

export default SidebarV2;
